import { ActionIcon, Button, Card, Group, Stack } from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import { useState } from "react";
import { GroupRatingCapsules } from "../components/RatingCapsules";
import { DateSelector } from "./DateSelector";
import { LocationSelector } from "./LocationSelector";
import { StagedRequestsList } from "./StagedRequestsList";
import { StagingGroupCardProps } from "./types";

export const StagingGroupCard = ({
  stagingGroup,
  availableDates,
  locations,
  isSelected,
  onSelect,
  onUpdateDate,
  onUpdateLocation,
  onRemoveRequest,
  onSave,
  onCreate,
  onDelete,
}: StagingGroupCardProps) => {
  const [showPersonalityTest, setShowPersonalityTest] = useState<{ [key: number]: boolean }>({});
  const [showReservationPreferences, setShowReservationPreferences] = useState<{
    [key: number]: boolean;
  }>({});

  const canCreateEvent =
    stagingGroup.selectedDate &&
    stagingGroup.selectedLocationId &&
    stagingGroup.stagedRequests.length > 0;

  const handleTogglePersonalityTest = (id: number) => {
    setShowPersonalityTest((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const handleToggleReservationPreferences = (id: number) => {
    setShowReservationPreferences((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  return (
    <Card
      shadow="sm"
      padding="lg"
      radius="md"
      withBorder
      onClick={onSelect}
      style={{
        cursor: "pointer",
        borderColor: isSelected ? "blue" : undefined,
        borderWidth: isSelected ? "2px" : "1px",
        position: "relative",
      }}
    >
      <ActionIcon
        variant="subtle"
        color="red"
        onClick={(e) => {
          e.stopPropagation();
          onDelete();
        }}
        style={{
          position: "absolute",
          top: "8px",
          right: "8px",
        }}
      >
        <IconX size={18} />
      </ActionIcon>
      <Stack>
        <GroupRatingCapsules stagingGroup={stagingGroup} />

        <LocationSelector
          selectedLocationId={stagingGroup.selectedLocationId}
          locations={locations}
          onChange={onUpdateLocation}
        />

        <DateSelector
          selectedDate={stagingGroup.selectedDate}
          availableDates={availableDates}
          onChange={onUpdateDate}
        />

        <StagedRequestsList
          stagedRequests={stagingGroup.stagedRequests}
          stagingGroup={stagingGroup}
          onRemoveRequest={onRemoveRequest}
          showPersonalityTest={showPersonalityTest}
          onTogglePersonalityTest={handleTogglePersonalityTest}
          showReservationPreferences={showReservationPreferences}
          onToggleReservationPreferences={handleToggleReservationPreferences}
        />

        <Group grow>
          <Button
            variant="outline"
            onClick={(e) => {
              e.stopPropagation();
              onSave();
            }}
            disabled={stagingGroup.stagedRequests.length === 0}
          >
            저장
          </Button>
          <Button
            onClick={(e) => {
              e.stopPropagation();
              onCreate();
            }}
            disabled={!canCreateEvent}
          >
            이벤트 생성
          </Button>
        </Group>
      </Stack>
    </Card>
  );
};
